import { DragAndDropListHook } from "commons/hooks/useDragAndDropList";

export type RenderInterface<T> = (row: T) => any;

export type RenderColorInterface<T> = (row: T) => any;

export type EmphasizeCellInterface<T> = (row: T) => string;

export type Column<T> = {
    id: string;
    header: string | JSX.Element;
    render: RenderInterface<T>;
    orderable?: boolean;
    width?: string;
    minWidth?: string;
    colSpan?: number;
    thColSpan?: number;
    thVerticalAlign?: "bottom" | "top" | "middle";
    align?: "start" | "end" | "left" | "right" | "center" | "justify" | "match-parent";
    headerAlign?: "start" | "end" | "left" | "right" | "center" | "justify" | "match-parent";
    linkContainer?: boolean;
    padding?: string;
    flex?: string;
    emptyContainer?: boolean;
    renderColor?: RenderColorInterface<T>;
    emphasizeCell?: EmphasizeCellInterface<T>;
};

export enum FilterOperation {
    Eq = "eq",
    NotEq = "noteq",
    Like = "like",
    Ge = "ge",
    Le = "le",
    In = "in",
    NotIn = "notin",
    Or = "or",
    And = "and",
    Is = "is",
    CollectionLike = "collection-like",
    CollectionEq = "collection-eq",
    CollectionNotEq = "collection-noteq",
    CollectionLe = "collection-le",
    CollectionIn = "collection-in",
    CollectionIs = "collection-is",
}

export enum SortDirection {
    NotOrdered = "",
    Desc = "DESC",
    Asc = "ASC",
}

export type FilterType = {
    key?: string;
    operation: FilterOperation;
    value:
        | string
        | number
        | boolean
        | Array<boolean>
        | Array<string>
        | Array<number>
        | null
        | undefined
        | Array<FilterType>;
};

export type SetFiltersInterface = (filters: Array<FilterType>) => void;

export type TableFilterType = {
    id: string;
    filter_group: string;
    filter_type: string;
    filters: any;
    favorite: boolean;
    version: number;
};

export type FilterField = {
    key?: string;
    operation?: FilterOperation;
    defaultValue?: any;
    label?: string;
    dontShowLabel?: boolean;
    dontShowLabelTitle?: boolean;
    dontFilter?: boolean;
    canBeFalse?: boolean;
    fields?: { [x: string]: FilterField };
};

export type FilterFieldCollection = {
    [x: string]: FilterField;
};

export type OnRowClickInterface<T> = (row: T) => void;

export type DisableOnRowClickInterface<T> = (row: T) => boolean;

export type EmphasizeRowInterface<T> = (row: T) => string;

export type GetElementsInterface<T> = (params: {
    data: Array<T>;
    columns: Array<Column<T>>;
    onRowClick?: OnRowClickInterface<T>;
    disableOnRowClick?: DisableOnRowClickInterface<T>;
    emphasizeRow?: EmphasizeRowInterface<T>;
    hideTableHead?: boolean;
    dragAndDropHook?: DragAndDropListHook<HTMLTableRowElement>;
    loading?: boolean;
}) => Array<JSX.Element>;

export type CalculateFiltersDescriptionInterface = (
    fields: FilterFieldCollection,
    form: { [y: string]: any },
    xlsx: boolean
) => Array<string>;

export type OnHeaderCellClickInterface<T> = (column: Column<T>) => void;

export type LoadTableDataInterface = (loadParams?: {
    rejectFetchError?: boolean;
}) => AbortController | undefined;
